import { HttpErrorResponse } from '@angular/common/http';
import { Category } from '@emi/shared/models';
import { createAction, props } from '@ngrx/store';

export const getCategories = createAction('[CategoryFilters] Get Categories');

export const getCategoriesSuccess = createAction('[CategoryFilters] Get Categories Success', props<{ categories: Category[] }>());

export const getCategoriesFailure = createAction('[CategoryFilters] Get Categories Failure', props<{ error: HttpErrorResponse }>());

export const fetchCategories = createAction('[CategoryFilters] Fetch Categories');

export const searchCategories = createAction(
    '[CategoryFilters] Get Categories With Search',
    props<{ searchText: string; delay: number }>()
);

export const searchCategoriesSuccess = createAction(
    '[CategoryFilters] Get Categories With Search Success',
    props<{ categories: Category[]; searchText: string | null }>()
);

export const isLoadingCategories = createAction('[CategoryFilters] Loading Categories');
